module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.6e1db655.svg";